// Cevap dili secenekleri. Su an yalnizca Ingilizce secilebilir (available);
// digerleri "not available" olarak readonly gosterilir — feature improvement
// vitrini. Backend ISO kodunu (answer_lang) kullanip cevabi o dilde uretir.

export type AnswerLangCode = "en" | "tr" | "de" | "fr" | "es";

export type AnswerLanguage = {
  code: AnswerLangCode;
  flag: string; // bayrak emoji (dil adinin basinda gosterilir)
  label: string; // dropdown'da gosterilen ad
  available: boolean;
};

export const ANSWER_LANGUAGES: AnswerLanguage[] = [
  { code: "en", flag: "🇬🇧", label: "English", available: true },
  { code: "tr", flag: "🇹🇷", label: "Turkish", available: false },
  { code: "de", flag: "🇩🇪", label: "German", available: false },
  { code: "fr", flag: "🇫🇷", label: "French", available: false },
  { code: "es", flag: "🇪🇸", label: "Spanish", available: false },
];

export const DEFAULT_ANSWER_LANG: AnswerLangCode = "en";
